module.exports = __webpack_public_path__ + "static/media/TradeGothicLTStd-Bd2Obl.fb236cbc.otf";